<div *ngFor="let model of models; let last = last" [style.paddingBottom]="!last ? '16px' : ''">
	<div style="font-weight: bold">{{ model?.title }}</div>
	<div style="padding-left: 8px">
		<div *ngFor="let item of model?.items" style="padding-top: 8px">
			<div *ngFor="let d of item?.data">
				{{ d }}
			</div>
		</div>
	</div>
</div>
